/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */

// Defines the supported sensor types
export enum Manufacturer {
  DICKEY_JOHN = 'DICKEY_JOHN',
  FORCE_AMERICA = 'FORCE_AMERICA',
  CIRUS = 'CIRUS',
  ROADWATCH = 'ROAD_WATCH'
}

/**
 * isDickeyJohn is a utility function that will return true if the manufacturer is Dickey John.
 * 
 * import {isDickeyJohn} from '@ion/core/src/entities';
 * 
 * isDickeyJohn(sensorType) && <SomeComponent />;
 * 
 * @param sensorType 
 * @returns 
 */
export const isDickeyJohn = (sensorType: string) => {
  return sensorType === Manufacturer.DICKEY_JOHN;
};

/**
 * 
 * isForceAmerica is a utility function that will return true if the manufacturer is Force America.
 * 
 * import {isForceAmerica} from '@ion/core/src/entities';
 * 
 * isForceAmerica(sensorType) && <SomeComponent />;
 * 
 * @param sensorType 
 * @returns 
 */
export const isForceAmerica = (sensorType: string) => {
  return sensorType === Manufacturer.FORCE_AMERICA;
};

/**
 * Simple utility which determines if the manufacturer is Cirus.
 * 
 * ```typescript
 *   import {isCirus} from '@ion/core/src/entities';
 * 
 *   isCirus(sensorType) && <SomeComponent />;
 * ```
 *
 * @param sensorType a string of the type of sensor
 * @returns `true` if the manufacturer is Cirus, otherwise `false`
 */
export const isCirus = (sensorType: string) => {
  return sensorType === Manufacturer?.CIRUS;
};

/**
 * Simple utility which determines if the manufacturer is RoadWatch.
 * 
 * ```typescript
 *   import {isRoadWatch} from '@ion/core/src/entities';
 * 
 *   isRoadWatch(sensorType) && <SomeComponent />;
 * ```
 *
 * @param sensorType a string of the type of sensor
 * @returns `true` if the manufacturer is Cirus, otherwise `false`
 */
export const isRoadWatch = (sensorType: string) => {
  return sensorType === Manufacturer?.ROADWATCH;
};

/**
 * getSpreaderSensorApps is a utility function that will return an array of supported spreader sensor apps.
 * 
 * import {getSpreaderSensorApps} from '@ion/core/src/entities';
 * 
 * const useSpreaderData = (
 * {
 *   id,
 *   sensorApps = getSpreaderSensorApps()
 * }: UseSpreaderParams,
 * ...
 * 
 * @returns array of spreader sensor apps
 */
export const getSpreaderSensorApps = () => {
  return Object.values(Manufacturer);
};
